import { render, staticRenderFns } from "./Height.vue?vue&type=template&id=32fac820&scoped=true&"
import script from "./Height.vue?vue&type=script&lang=js&"
export * from "./Height.vue?vue&type=script&lang=js&"
import style0 from "./Height.vue?vue&type=style&index=0&id=32fac820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fac820",
  null
  
)

export default component.exports